<nav class="wrapper" [class.minify]="minify">
  <ul class="sidebar">
    <menu-item
      titleItem="Overview"
      i18n-titleItem="@@menu.overview"
      link="/dashboard"
      icon="icon-i-dashboard"
      [inverseMode]="inverseMode"
      [minify]="minify"
    ></menu-item>

    <menu-item
      titleItem="Wallets"
      i18n-titleItem="@@menu.wallets"
      link="/accounts"
      icon="icon-i-wallet"
      [inverseMode]="inverseMode"
      [minify]="minify"
    ></menu-item>
  
    <menu-item
      titleItem="Lite Exchange"
      i18n-titleItem="@@menu.lite"
      link="/lite"
      icon="icon-i-lite"
      [inverseMode]="inverseMode"
      [minify]="minify"
    ></menu-item>
  
    <menu-item
      titleItem="Pro Trading"
      i18n-titleItem="@@menu.pro"
      link="/pro"
      icon="icon-i-pro"
      [inverseMode]="inverseMode"
      [minify]="minify"
    ></menu-item>
  
    <menu-item
      titleItem="Verification"
      i18n-titleItem="@@menu.verification"
      link="/verification"
      icon="icon-i-security"
      [inverseMode]="inverseMode"
      [minify]="minify"
    ></menu-item>
  
    <menu-item
      titleItem="Settings"
      i18n-titleItem="@@menu.settings"
      link="/settings"
      icon="icon-i-settings"
      [inverseMode]="inverseMode"
      [minify]="minify"
    >
      <ng-template #submenu>
        <ng-container *ngTemplateOutlet="settingsSubMenu"></ng-container>
      </ng-template>
    </menu-item>
  </ul>
</nav>

<ng-template #settingsSubMenu>
  <ul class="sidebar sub" [class.inverse]="inverseMode">
    <menu-item
      titleItem="General Settings"
      i18n-titleItem="@@menu.settings.general"
      link="/settings/general"
      isSubItem="true"
      icon="icon-dot"
      [inverseMode]="inverseMode"
    ></menu-item>

    <menu-item
      titleItem="Payment Settings"
      i18n-titleItem="@@menu.settings.payment"
      link="/settings/payments"
      isSubItem="true"
      icon="icon-dot"
      [inverseMode]="inverseMode"
    ></menu-item>

    <menu-item
      titleItem="Limits"
      i18n-titleItem="@@menu.settings.limits"
      link="/settings/limits"
      isSubItem="true"
      icon="icon-dot"
      [inverseMode]="inverseMode"
    ></menu-item>

    <menu-item
      titleItem="Security"
      i18n-titleItem="@@menu.settings.security"
      link="/settings/security"
      isSubItem="true"
      icon="icon-dot"
      [inverseMode]="inverseMode"
    ></menu-item>

    <menu-item
      titleItem="Notifications"
      i18n-titleItem="@@menu.settings.notifications"
      link="/settings/notifications"
      icon="icon-dot"
      isSubItem="true"
      [inverseMode]="inverseMode"
    ></menu-item>
  </ul>
</ng-template>
